module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (110).3d0ef924.jpg";